import boardEntryApi from '@/apis/board_entry';
import { dtFormat } from '@/lib/dateHelper';
import { downloadBlob } from '@/lib/downloadHelper';
import { BoardEntryIndexParams } from '@/models/apis/settouMessageBoard/settouMessageBoardRequest';
import {
  TabFilterState,
  BoardEntryListState,
  BoardEntryModalState,
} from '@/models/settouMessageBoard';
import {
  SearchParams,
  convSearchParamDateFromTo,
} from '@/components/SettouMessageBoard/utils/index';
import { createInjection } from '@/lib/createInjection';

interface BoardCsvExportOptions {
  tabState: TabFilterState;
  entryListState: BoardEntryListState;
  modalState: BoardEntryModalState;
  getLatestSearchParams: () => SearchParams | null;
}

export interface UseBoardCsvExportResult {
  downloadCSV: () => Promise<void>;
}

const { provide, inject } = createInjection<UseBoardCsvExportResult>('settouMessageBoard/useBoardCsvExport');

export function provideBoardCsvExport(options: BoardCsvExportOptions): void {
  provide(buildBoardCsvExport(options));
}

export function useBoardCsvExport(): UseBoardCsvExportResult {
  return inject();
}

// 検索条件に沿った投稿一覧のCSV出力を担う composable。
function buildBoardCsvExport(options: BoardCsvExportOptions): UseBoardCsvExportResult {
  const { tabState, entryListState, modalState, getLatestSearchParams } = options;

  const downloadCSV = async(): Promise<void> => {
    const latestSearchParams = getLatestSearchParams();
    if (entryListState.isDownloading || !latestSearchParams) return;

    entryListState.isDownloading = true;
    const [dateFrom, dateTo] = convSearchParamDateFromTo(latestSearchParams.dateFrom, latestSearchParams.dateTo);
    const searchParams: BoardEntryIndexParams = {
      board_master_id: tabState.currentTabId,
      date_from: dateFrom,
      date_to: dateTo,
      han: latestSearchParams.han ?? null,
      is_reported_to_honsha: latestSearchParams.reportToHonsha ?? null,
      company_name: latestSearchParams.companyName ?? null,
    };
    try {
      const { data } = await boardEntryApi.downloadCSV(searchParams);
      const timestamp = dtFormat(new Date(), 'yyyymmdd_HHMMSS');
      const filename = `掲示板_${timestamp}`;
      downloadBlob(data, filename);
    } catch (e) {
      console.error('error', e);
      modalState.errorBody = 'CSVダウンロードに失敗しました。再度操作を行ってください';
    } finally {
      entryListState.isDownloading = false;
    }
  };

  return {
    downloadCSV,
  };
}
